import { render, staticRenderFns } from "./packageManage.vue?vue&type=template&id=729c169e&scoped=true"
import script from "./packageManage.vue?vue&type=script&lang=js"
export * from "./packageManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c169e",
  null
  
)

export default component.exports